// Texty časovej osi doručenia — slovenské dvojča locale/cs/deliveryTimeline.js.
import D from './dispatchEta.js';

export default {
  days: D.days,
  today: D.today,
  tomorrow: D.tomorrow,
  withCarrier: (carrier) => 's ' + carrier,
  fastest: 'Najrýchlejšie',
  satPromoToday: (cutoff) => 'Objednajte do ' + cutoff + ' a s GLS máte balík už zajtra, v sobotu ',
  satPromoLater: 'Odošleme v piatok a s GLS máte balík už v sobotu ',
  sunPromoToday: 'Objednajte dnes do polnoci, odošleme v nedeľu a s PPL máte balík už v pondelok ',
  sunPromoLater: 'Objednajte do sobotnej polnoci, odošleme v nedeľu a s PPL máte balík už v pondelok ',
  orderSunToday: 'dnes do polnoci',
  orderSunLater: 'do sobotnej polnoci',
  orderToday: (cutoff) => 'dnes do ' + cutoff,
  orderMidnight: 'dnes do polnoci',
  shipToday: 'ešte dnes',
  range: (from, to) => from + ' – ' + to,
  hours: 'h',
  minutes: 'min',
};
